var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 12.1457,
    rx: 10.1479,
    ry: 10.613,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.1457C0 18.4894 4.93509 23.6498 11 23.6498C17.0658 23.6498 22 18.4894 22 12.1457C22 5.80284 17.0658 0.641602 11 0.641602C4.93509 0.641602 0 5.80284 0 12.1457ZM1.7041 12.1457C1.7041 6.78482 5.87404 2.42379 11 2.42379C16.126 2.42379 20.2959 6.78482 20.2959 12.1457C20.2959 17.5056 16.126 21.8676 11 21.8676C5.87404 21.8676 1.7041 17.5065 1.7041 12.1457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67087 16.3783C9.44253 16.3783 9.22438 16.283 9.06333 16.1119L5.91927 12.7703C5.58953 12.4192 5.59378 11.856 5.92949 11.5103C6.26521 11.1663 6.80455 11.1699 7.13429 11.521L9.64616 14.1907L14.8428 8.20518C15.1606 7.84073 15.6992 7.81489 16.0459 8.1446C16.3944 8.47521 16.42 9.03837 16.1039 9.40371L10.3014 16.0869C10.1438 16.2687 9.92224 16.3738 9.68793 16.3792C9.68196 16.3783 9.67684 16.3783 9.67087 16.3783Z",
    fill: "#89B620"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast-success.6aadab40.svg";
export { ForwardRef as ReactComponent };